import { Link } from 'react-router-dom';
import { BRANDS } from '../data/brands';
import { useAuth } from '../../../login/ux/hooks/useAuth';

export function Footer() {
  const { isAuthenticated } = useAuth();

  return (
    <footer className="bg-ink text-cream">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-10 md:flex-row md:items-center md:justify-between">
        <div className="flex items-baseline gap-2">
          <span className="font-display text-2xl italic">A2</span>
          <span className="text-cream/60 text-xs tracking-[0.22em] uppercase">Agency</span>
        </div>

        <p className="text-cream/60 text-sm">
          © {new Date().getFullYear()} A2 Agency. Influencer marketing for consumer AI &amp; SaaS brands.
        </p>

        <div className="text-cream/80 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <a
            href="mailto:hello@a2.agency"
            className="hover:text-cream transition-colors duration-200"
          >
            Email
          </a>
          {BRANDS.map((brand) => (
            <a
              key={brand.name}
              href={brand.url}
              target="_blank"
              rel="noreferrer noopener"
              className="hover:text-cream transition-colors duration-200"
            >
              {/* "Mila.gg" → "Mila", "Tryclosed.com" → "Tryclosed". */}
              {brand.name.replace(/\.(gg|com)$/, '')}
            </a>
          ))}
          <Link to="/creator" className="hover:text-cream transition-colors duration-200">
            Creator login
          </Link>
          <Link
            to={isAuthenticated ? '/pipeline' : '/login'}
            className="hover:text-cream transition-colors duration-200"
          >
            {isAuthenticated ? 'CRM' : 'Staff login'}
          </Link>
        </div>
      </div>
    </footer>
  );
}
